/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PortfolioDto } from '../../models/portfolio-dto';

export interface PortfolioAdminControllerSearchCursorV1$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 커서
 */
  cursor?: string;
}

export function portfolioAdminControllerSearchCursorV1(http: HttpClient, rootUrl: string, params: PortfolioAdminControllerSearchCursorV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<PortfolioDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}>> {
  const rb = new RequestBuilder(rootUrl, portfolioAdminControllerSearchCursorV1.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('cursor', params.cursor, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'items': Array<PortfolioDto>;
      
      /**
       * 다음 페이지의 커서 값
       */
      'nextCursor'?: string | null;
      
      /**
       * 다음 페이지 존재 여부
       */
      'hasNext': boolean;
      }>;
    })
  );
}

portfolioAdminControllerSearchCursorV1.PATH = '/api/v1/portfolios/admin/search/cursor';
